
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1isd1_1ft5c_9",
  "marker--line": "awsui_marker--line_1isd1_1ft5c_49",
  "marker--rectangle": "awsui_marker--rectangle_1isd1_1ft5c_53",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_1isd1_1ft5c_60",
  "marker--dashed": "awsui_marker--dashed_1isd1_1ft5c_76"
};
  